import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, } from '../../../../helpers/custom-prop-types';
import ConsultantSearchProfessionalSlider from '../../../Ui/ConsultantSearch/Slider/ConsultantSearchProfessionalSlider';
const SearchPickup = (props) => {
    const { isLg, isMd, isPre, isXl, loading, professionals, showPreModal } = props;
    return (_jsxs("div", Object.assign({ className: 'card_body_section card_body_section_slider' }, { children: [_jsx("div", Object.assign({ className: 'card_body_section_header' }, { children: _jsx("h5", Object.assign({ className: 'card_body_section_pickup_label' }, { children: "Pick Up" })) })), _jsx(ConsultantSearchProfessionalSlider, { isLg: isLg, isMd: isMd, isPre: isPre, isXl: isXl, loading: loading, professionals: professionals, showPreModal: showPreModal }, isXl)] })));
};
SearchPickup.propTypes = {
    isLg: propBool().isRequired,
    isMd: propBool().isRequired,
    isPre: propBool().isRequired,
    isXl: propBool().isRequired,
    loading: propBool().isRequired,
    professionals: propArrayShape().isRequired,
    showPreModal: propFunc().isRequired,
};
export default SearchPickup;
